import { Auth } from "aws-amplify";

/**
 * Centralized forgot password utility.
 * Simply calls Cognito's forgotPassword without any database lookups.
 * 
 * @param username - The email/username to reset password for
 * @returns Promise that resolves when the forgot password flow is initiated
 * @throws Error if the forgot password request fails
 */
export const handleForgotPassword = async (username: string): Promise<void> => {
  try {
    await Auth.forgotPassword(username);
  } catch (error) {
    console.error("forgotPassword error:", error);
    // Re-throw the error so the caller can handle it appropriately
    // Amplify will show appropriate error messages to the user
    throw error;
  }
};

/**
 * Hook to trigger forgot password flow from components outside the Authenticator.
 * Uses sessionStorage to signal the SignInFooter to trigger the forgot password flow.
 * 
 * @param navigate - Navigation function from react-router-dom
 */
export const useForgotPasswordRedirect = (navigate: (path: string) => void) => {
  return () => {
    try {
      sessionStorage.setItem("forceResetPassword", "true");
    } catch {
      // sessionStorage might be unavailable; ignore
    }
    navigate("/");
  };
};

